import { Card, CardBody, CardFooter, CardHeader, Col, Row } from 'reactstrap';
import { Link, Navigate } from 'react-router-dom';
import { useMemo } from 'react';
import { useAppSelector } from '../../hooks';
import Loading from '../Loading';
import LinearScaleIcon from '@mui/icons-material/LinearScaleOutlined';
import { LineChart } from '@mui/x-charts';

type Props = {
    data: (number | null)[];
    data2: (number | null)[];
    labels: String[];
    branch: number;
};

const SellAThonGraph = ({ data, data2, labels, branch }: Props) => {
    const loading = useAppSelector((state) => state.sales.loading);

    if (loading) {
        return (
            <Loading />
        )
    }

    return (
        <Card>
            <Link to='/SalesReport' style={{ textDecoration: 'none', color: 'black' }}>
                <CardHeader className='bg-white'>    
                    <span
                        style={{
                            textAlign: 'center',
                            marginBottom: 10,
                            fontSize: 16,
                            fontWeight: 'bold'
                    }}>Branch {branch}</span>
                </CardHeader>
            </Link>
            <CardBody>    
                    {loading 
                        ? (<Loading />)
                        : (
                            <LineChart
                                margin={{ left: 0, right: 10}}
                                xAxis={[
                                    {
                                        scaleType: 'point',
                                        data: labels,
                                    },
                                ]}
                                yAxis={[
                                    {
                                        width: 55,
                                    }
                                ]}
                                series={[
                                    {
                                        data: data2,
                                        label: 'Current Year',
                                        color: '#f1b434'
                                        
                                    },
                                    {
                                        data,
                                        label: 'Last Year',
                                        color: 'lightgray'
                                    },
                                ]}
                                height={300}                                
                            />
                        )
                    }
            </CardBody>
            <CardFooter className='bg-white'>
                <Row>
                    <span style={{ textAlign: 'center' }}>Sales in thousands $</span>
                </Row>
            </CardFooter>
        </Card>
    )
};

export default SellAThonGraph;
